(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHeader(root) {
    if (!root || root.dataset.vensollInit === 'true') return;
    root.dataset.vensollInit = 'true';

    var menuToggle = root.querySelector('[data-menu-toggle]');
    var mobilePanel = root.querySelector('[data-mobile-panel]');

    if (menuToggle && mobilePanel) {
      menuToggle.addEventListener('click', function () {
        var open = mobilePanel.classList.toggle('vs-open');
        menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      mobilePanel.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          mobilePanel.classList.remove('vs-open');
          menuToggle.setAttribute('aria-expanded', 'false');
        });
      });
    }
  }

  document.querySelectorAll('[data-vensoll-header-root]').forEach(initHeader);
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-vensoll-header-root]');
    if (root) initHeader(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vensollhomepage"] && !Shopify.designMode) return;
  try {
    

(function () {
  function initInstance(root) {
    root.querySelectorAll('.vs-faq-item').forEach(function (item) {
      var q = item.querySelector('.vs-faq-q');
      var a = item.querySelector('.vs-faq-a');
      if (!q || !a) return;
      var setState = function (open) {
        item.classList.toggle('vs-open', open);
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
        a.style.maxHeight = open ? a.scrollHeight + 'px' : '0px';
      };
      setState(item.classList.contains('vs-open'));
      q.addEventListener('click', function () {
        setState(!item.classList.contains('vs-open'));
      });
    });
    window.addEventListener('resize', function () {
      root.querySelectorAll('.vs-faq-item.vs-open .vs-faq-a').forEach(function (a) {
        a.style.maxHeight = a.scrollHeight + 'px';
      });
    });

    var plans = root.querySelectorAll('.vs-plan');
    var form = root.querySelector('.vs-buy-form');
    if (plans.length && form) {
      var variantInput = form.querySelector('.vs-selected-variant-id');
      var sellingPlanInput = form.querySelector('.vs-selected-selling-plan-id');
      var addBtn = form.querySelector('.vs-add-to-cart');

      function selectPlan(plan) {
        plans.forEach(function (p) {
          p.classList.remove('vs-selected');
          p.setAttribute('aria-checked', 'false');
        });
        plan.classList.add('vs-selected');
        plan.setAttribute('aria-checked', 'true');
        if (variantInput) variantInput.value = plan.dataset.variantId || '';
        if (sellingPlanInput) sellingPlanInput.value = plan.dataset.sellingPlanId || '';
        if (addBtn && plan.dataset.buttonLabel) addBtn.textContent = plan.dataset.buttonLabel;
      }

      plans.forEach(function (plan) {
        plan.addEventListener('click', function () { selectPlan(plan); });
        plan.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            selectPlan(plan);
          }
        });
      });

      var initial = root.querySelector('.vs-plan.vs-selected') || plans[0];
      if (initial) selectPlan(initial);
    }

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var revealEls = root.querySelectorAll('.vs-reveal');
    if (!reduceMotion && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.remove('vs-pre');
              entry.target.classList.add('vs-in');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
      );
      revealEls.forEach(function (el) {
        el.classList.add('vs-pre');
        io.observe(el);
      });
    }
  }

  document.querySelectorAll('.vs-home').forEach(initInstance);
})();


  } catch(e) { console.error(e); }
})();
})();
